import { flow } from 'fp-ts-esm/function';

import type { Node } from './../../ricos-schema/next-schema/index.js';

import type { Extractor } from '../extractor-infra.js';
import { getExtractor } from '../extractor-infra.js';

const nodesAccessor = (node: Node): Node[] =>
  Array.isArray(node.nodes) ? (node.nodes as Node[]) : [];

const getRootNode = (nodes: Node | Node[]): Node =>
  Array.isArray(nodes)
    ? ({
        id: 'root',
        type: 'UNRECOGNIZED',
        nodes,
      } as unknown as Node)
    : nodes;

export const extract: (nodes: Node | Node[]) => Extractor<Node> = flow(
  getRootNode,
  getExtractor<Node>(nodesAccessor)
);
